export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["接受者"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["创建者"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["接受者 ID"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["创建者 ID"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["您支付"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["您收到"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["等待时间"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["名称"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["银行账户/钱包"])},
  "10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["描述"])},
  "11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["无银行名称"])},
  "12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["无银行账户"])},
  "13": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["未提供名称"])},
  "14": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["未提供账户"])},
  "15": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["外部"])},
  "16": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["内部"])}
}